import { useContext } from 'react';
import { useQuery } from 'react-query';
import { apiGet } from 'api';
import AuthContext from 'context/auth-context';

const getDataPipelines = async (token, params = {}) => {
  const url = 'admin/data_pipelines';
  const data = await apiGet({ url, token, params });
  return data;
};

export function useAdminDataPipelines({ params = {}, options } = {}) {
  const token = useContext(AuthContext);
  const queryFn = () => getDataPipelines(token, params);
  const queryKey = ['admin-data-pipelines', JSON.stringify(params)];
  return useQuery(queryKey, queryFn, { keepPreviousData: true, ...options });
}
